import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export const contactData = [
  {
    title: 'Telefon',
    description: 'Zadzwoń do nas w godzinach otwarcia',
    value: '+48 668 700 455',
    href: 'tel:+48 668 700 455',
    icon: <Phone />,
  },
  {
    title: 'E-mail',
    description: 'Napisz do nas',
    value: 'centrumrozwojumotus@gmail.com',
    href: 'mailto: centrumrozwojumotus@gmail.com',
    icon: <Mail />,
  },
  {
    title: 'Adres',
    description: 'Odwiedź nas osobiście',
    value: 'Targowa 6d, 32-005 Niepołomice',
    href: 'https://www.google.com/maps?q=Centrum+Rozwoju+i+Terapii+Motus,+Niepołomice',
    icon: <MapPin />,
  },
  {
    title: 'Godziny',
    description: 'Pn - Pt 8:00 - 20:00 / Sob: Nieczynne',
    value: null,
    href: null,
    icon: <Clock />,
  },
];
